export const LIMIT_OF_FLIGHT_PROPOSAL = 5;
